module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day03_03_stay-6c7b10065afeb5cea41d247b9e4439f8.jpg";